module.exports = __webpack_public_path__ + "img/img1.293d4e3b.png";